import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/v1/module-attachement-files', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/module-attachement-files/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { store, destroy }
